import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCan_l2O91yn-ImhsWwsb2Y6ThATDUDh3E",
    authDomain: "ezguide-68275.firebaseapp.com",
    projectId: "ezguide-68275",
    storageBucket: "ezguide-68275.firebasestorage.app",
    messagingSenderId: "1034740148085",
    appId: "1:1034740148085:web:ff259ceccef2143b89553c",
    measurementId: "G-MCKTQ0STJG"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };